<tui-segmented *transloco="let t" class="w-fit" size="s" [activeItemIndex]="(selectedIndex$ | async) ?? -1">
  @for (button of buttons$ | async; track button.value; let index = $index) {
    <button type="button" [attr.data-testid]="button.testId" (click)="updateFilters(button, index)">
      {{ t(button.display) }}
      @if (button.count) {
        <tui-badge-notification data-testid="filter-count" size="s">
          {{ button.count }}
        </tui-badge-notification>
      }
    </button>
  }
</tui-segmented>
